import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useSpacingOffset } from '../../helpers/useSpacingOffset';
import { useWindowPosition } from '../utils';

export const EmbedChat = ({ children }: PropsWithChildren) => {
  const { width } = useWindowPosition();
  const { verticalOffset, horizontalOffset } = useSpacingOffset();

  return (
    <Container
      _width={width}
      _verticalSpacing={verticalOffset}
      _horizontalSpacing={horizontalOffset}
    >
      {children}
    </Container>
  );
};

const Container = styled.div<{
  _width: number | string;
  _verticalSpacing: number;
  _horizontalSpacing: number;
}>`
  position: relative;

  width: ${({ _width }) => _width}px;

  margin: ${({ _verticalSpacing, _horizontalSpacing }) =>
    `${_verticalSpacing}px ${_horizontalSpacing}px`};
`;
